import React from 'react';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { TableVirtuoso } from 'react-virtuoso';
import { IST_HM } from '../chartTheme';

function formatTs(iso) {
    try {
        return IST_HM.format(new Date(iso));
    } catch {
        return iso;
    }
}

const columns = ['Time', 'Side', 'Qty', 'Price', 'Realized PnL'];

export default function FillsTable({ fills = [] }) {
    if (!fills.length) {
        return (
            <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
                No fills — run a backtest to see executions.
            </Typography>
        );
    }

    return (
        <TableContainer component={Box} sx={{ height: 360 }}>
            <TableVirtuoso
                data={fills}
                components={{
                    Table: (props) => <Table {...props} size="small" stickyHeader />,
                    TableHead,
                    TableRow,
                    TableBody,
                }}
                fixedHeaderContent={() => (
                    <TableRow>
                        {columns.map((col) => (
                            <TableCell key={col} sx={{ fontWeight: 600, fontSize: 11 }}>
                                {col}
                            </TableCell>
                        ))}
                    </TableRow>
                )}
                itemContent={(_index, row) => (
                    <>
                        <TableCell sx={{ fontSize: 11, fontFamily: 'monospace' }}>
                            {formatTs(row.ts)}
                        </TableCell>
                        <TableCell
                            sx={{
                                fontSize: 11,
                                fontWeight: 600,
                                color: row.side === 'buy' ? 'success.main' : 'error.main',
                                textTransform: 'uppercase',
                            }}
                        >
                            {row.side}
                        </TableCell>
                        <TableCell sx={{ fontSize: 11 }}>{row.qty}</TableCell>
                        <TableCell sx={{ fontSize: 11 }}>{row.price?.toFixed?.(2) ?? row.price}</TableCell>
                        <TableCell sx={{ fontSize: 11 }}>
                            {row.realized_pnl != null ? row.realized_pnl.toFixed(2) : '—'}
                        </TableCell>
                    </>
                )}
            />
        </TableContainer>
    );
}
